import { URLS } from "../constants";
import api from "../utils/api";

export interface CompanyAddress {
  id: string;
  zip_code: string;
  street: string;
  number: string;
  city: string;
  state: string;
  country: string;
}

export interface CompanyInfo {
  id: string;
  name: string;
  fantasy_name: string;
  cnpj: string;
  area: string;
  telephone: string[];
  email: string;
  subscription: string;
  subscription_message: string;
  instagram_profile: string;
  website: string;
  address: CompanyAddress;
  admin_emails: string[];
  phone_numbers: string[];
  is_crm_connected: boolean;
  ai_session_id: string;
  crm: string;
}

export async function getCompanyInfo(): Promise<CompanyInfo> {
  const res = await api.get(`${URLS.CLIENT_URL}/api/get-info-company`, {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
  if (res.status !== 200) {
    throw new Error(`Error searching for company: ${res.status}`);
  }
  return res.data as CompanyInfo;
}
